<template>

  <v-container >
    

    <v-layout row wrap justify-center >
      <v-flex xs12 lg8 xl8>
        <!-- <v-card v-bind:style="{ 'background-color:black; background-image': 'url(' + meetup.imageUrl + '); ' }"> -->
        <v-card style="background-color:rgba(38, 50, 56, 1);">
         
          <img
            :src="meetup.imageUrl"
            width="100%" height="auto"
            :alt="meetup.title"
          ></img>
          
          <v-card-title>
             <div>
              <h5 class="white--text"  >{{ meetup.title }}</h5>
              <p class="white--text"  >{{ meetup.description }}</p>
            </div>
          </v-card-title>
          <v-card-title class ="pb-0" >
            <div>
             <!-- <span class="white--text"  >Stage{{ meetup.stageNo }} </span> -->
             <span class="white--text pr-2"  > {{ meetup.category }} </span>
             <v-icon>place</v-icon><span class="white--textpr pr-2"  > {{ meetup.tag }} </span>
             <v-icon >event</v-icon><span class="white--text pr-2"  > {{ meetup.date | date }} </span>
            </div>
          </v-card-title>
           <v-card-title class ="pt-1">
            <div>
            
<!-- <icon name="refresh" scale="2" spin></icon>
<icon name="comment" flip="horizontal"></icon>
<icon name="code-fork" label="Forked Repository"></icon>
<icon label="No Photos">
  <icon name="camera"></icon>
  <icon name="ban" scale="2" class="alert"></icon>
</icon> -->
             <!-- <span class="white--text"  >Stage{{ meetup.stageNo }} </span> -->
             <!-- <span class="white--text pr-2"  > {{ meetup.category }} </span> -->
             <!-- <v-icon>link</v-icon><span class="white--textpr pr-2"  > {{ meetup.link }} </span> -->
             <a v-bind:href="meetup.link" target="_blank"><p class="image-link white--text">Blog Page<v-icon color="white darken-1">chevron_right</v-icon></p></a>
            </div>
          </v-card-title>
          
          <template v-if="userIsCreator">
              <v-spacer></v-spacer>
              <app-edit-details-dialog :meetup="meetup"></app-edit-details-dialog>
              <app-edit-date-dialog :meetup="meetup"></app-edit-date-dialog>
          </template>
          
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
           
            <app-edit-Register-dialog :meetupId="meetup.id"></app-edit-Register-dialog>
          </v-card-actions> -->
        </v-card>
      </v-flex>
      <v-flex  xs12 lg8 xl8 style="text-align: left;">
         <v-btn  @click="goBack">
                Back
                  <span slot="loader" class="custom-loader">
                  <v-icon>cached</v-icon>
                  </span>
              </v-btn>
      </v-flex>
    </v-layout>

    
  </v-container>
</template>

<script>
export default {
 props: ['id'],
 methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    }
  },
 computed: {
      meetup () {
        return this.$store.getters.loadedMeetup(this.id)
      },
      userIsAuthenticated () {
        return this.$store.getters.user !== null && this.$store.getters.user !== undefined
      },
      userIsCreator () {
        if (!this.userIsAuthenticated) {
          return false
        }
        return this.$store.getters.user.id === this.meetup.creatorId
      },
      loading () {
        return this.$store.getters.loading
      }

    }

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

/* h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
} */

</style>



// WEBPACK FOOTER //
// src/components/awards/awardsEntry.vue